module.exports = __webpack_public_path__ + "static/media/newLogo.17a5a13f.png";